import React, { useState, useEffect,memo } from 'react'

// nodejs library to set properties for components
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { Link } from 'react-router-dom';
import {useSelector} from 'react-redux'
import {ServerConfig} from 'config'
import axios from 'axios'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid, Hidden, Container } from '@material-ui/core'
import { ListGroup, ListGroupItem } from 'reactstrap';
import { AppBar, Tabs, Tab } from '@material-ui/core';
import Box from "@material-ui/core/Box";

// components
import Page from 'components/Page/Page'
import _, { get } from 'lodash'
import { hasPermission } from 'utils/hasPermission';

import Messaging from './Messaging.js'
import Waitlist from './Waitlist.js'
import AddPost from './AddBlogPost';
import DisplayPosts from './DisplayBlogPost';
import SupportEntries from './Support.js';


const useStyles = makeStyles((theme) => ({ }))

const PublicRelationsPage = ({children}) => {
  const auth = useSelector(state => state.auth)
  const classes = useStyles()

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div {...other}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  }

  if(!auth.access_token){
    return <Redirect to="/login" />
  }

  const isAdmin = hasPermission(auth.permissions, ['Admin', 'admin']);


  return (
    <Page title="Public Relations">
        <Container maxWidth={false} >

        <AppBar position="static">
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Messaging" />
            <Tab label="Waitlists" />
            <Tab label="Blogposts" />
            <Tab label="Add Blogpost" />
            <Tab label="Support" />
          </Tabs>
        </AppBar>
        {
          isAdmin && (
            <>
              <TabPanel value={value} index={0}>
                <Messaging />
              </TabPanel>

              <TabPanel value={value} index={1}>
                <Waitlist />
              </TabPanel>

              <TabPanel value={value} index={2}>
                <DisplayPosts />
              </TabPanel>

              <TabPanel value={value} index={3}>
                <AddPost />
              </TabPanel>  

              <TabPanel value={value} index={4}>
                <SupportEntries />
              </TabPanel>
            </>
          )
        }
        </Container>
    </Page>
  )
}

export default PublicRelationsPage

PublicRelationsPage.propTypes = {
  children: PropTypes.node
}
